import axios, { AxiosResponse } from 'axios';
import { api } from 'services/companiesApi';

export const getNewCampaignSettings = async (
	type: string,
): Promise<AxiosResponse> => {
	return await api.get(`/questionnaires?type=${type}`);
};

export const postNewCampaignSettings = async (
	payload: any,
): Promise<AxiosResponse> => {
	return await api.post('/campaigns', payload);
};

export const submitSectionForm = async (
	payload: any,
	method: any,
): Promise<AxiosResponse> => {
	const instanceApi: any = api;
	return await instanceApi[method](
		`/campaigns/${payload.campaignId}/communications/${payload.id ?? ''}`,
		{
			...payload,
		},
	);
};

export const getSectionCommunication = async (
	campaignId: string,
): Promise<AxiosResponse> => {
	return await api.get(`/campaigns/${campaignId}/communications`);
};

export const postSectionPreSignedUrl = async (
	payload: any,
): Promise<AxiosResponse> => {
	return await api.post(`/campaigns/communications/file`, payload);
};

export const postSectionFile = async (
	url: any,
	file: any,
	contentType: string,
): Promise<AxiosResponse> => {
	return await axios.put(url, file, {
		headers: { 'Content-Type': contentType },
	});
};

export const getCampaigns = async (): Promise<AxiosResponse> => {
	return await api.get('/campaigns');
};

export const getCampaign = async (id: string): Promise<AxiosResponse> => {
	return await api.get(`/campaigns/${id}`);
};

export const getHtmlPreview = async (
	campaignId: string,
	communicationTypeId: string,
	useCustomTemplate: boolean,
	messageBoby: string,
): Promise<AxiosResponse> => {
	return await api.get(`/campaigns/${campaignId}/mail-template`, {
		params: {
			useCustomTemplate: useCustomTemplate,
			communicationTypeId: communicationTypeId,
			messageBody: messageBoby,
		},
	});
};
